import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { sendAnalyticsEvents } from '../../analytics/common'
import { EVENTS } from '../../analytics/events'
import {selectEventsData, setAnalyticsData} from '../events/eventsSlice'
import DefaultPlans from './DefaultPlans'
import { selectLandingType, selectShowPaywall, selectShowCheckout } from './plansSlice'
import TrialPlan from './TrialPlan'
import IntroPlan from './IntroPlan'
import { selectWebp } from '../ui/uiSlice'
import {
  checkoutImagesLinks,
  checkoutWebpImagesLinks,
} from '../../helper/utils'
import {useAnalyticsData} from '../checkout/helper';
import { usePreloadImages } from '../../helper/useImagePreloader'
import { getGeoCode, getLocationByIP, setCountry, setInitCoords, setLoadStatus } from './map/mapSlice'
import useSrcScript from '../../helper/useSrcScript'
import googleSrc from '../../scripts/googlePlaces';
import OnePagePlans from './OnePagePlans';

const PlansScreen = ({ history, onePage }) => {
  const dispatch = useDispatch()
  const landingType = useSelector(selectLandingType)
  const isWebp = useSelector(selectWebp)
  const amplitudeEventsData = useSelector(selectEventsData)
  const isTrialPlan = ['trial', 'trialb', 'trial-anim'].includes(landingType);
  const isIntroPlan = ['intro', 'introb', 'intro-anim'].includes(landingType);
  const analyticsParams = useAnalyticsData()
  const status = useSrcScript(googleSrc, landingType === 'map');
  const showPaywall = useSelector(selectShowPaywall);
  const showCheckout = useSelector(selectShowCheckout);
  const getInitialLocation = async () => {
    const country = await getLocationByIP();
    const coords = await getGeoCode(country);
    dispatch(setCountry(country));

    return { lat: parseFloat(coords.lat), lng: parseFloat(coords.lon) };
  };

  usePreloadImages(isWebp ? checkoutWebpImagesLinks : checkoutImagesLinks);

  useEffect(() => {
    if (status === 'ready') {
      dispatch(setLoadStatus(true));
    }
  }, [status, dispatch]);

  useEffect(() => {
    landingType === 'map' && getInitialLocation().then((r) => dispatch(setInitCoords(r)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, landingType]);

  useEffect(() => {
    if (Object.keys(analyticsParams).length > 0) {
      dispatch(setAnalyticsData(analyticsParams));
    }
  }, [analyticsParams, dispatch]);

  useEffect(() => {
    if (!onePage) {
      const eventToTrack = showPaywall && !showCheckout
        ? EVENTS.mapPaywallShown
        : !showCheckout
          ? EVENTS.onboardingPaywallShown
          : null;
      !!eventToTrack && sendAnalyticsEvents(eventToTrack, amplitudeEventsData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCheckout, showPaywall, onePage]);
  if (isIntroPlan) {
    return <IntroPlan />
  }
  if (isTrialPlan) {
    return <TrialPlan />
  }
  if (onePage) {
    return <OnePagePlans history={history} />
  }
  return <DefaultPlans />
}

export default PlansScreen
